import { takeLatest, call, put } from "redux-saga/effects";
import { sessionCheckFailure, sessionCheckSuccess } from "../action/sessionAction";
import * as _api from "../../api";
import * as types from "../types";

function* asyncSessionCheckSaga() {
  try {
    let sessionData = yield call(_api.getSessionStatus);
    yield put(sessionCheckSuccess({ sessionData }));
  } catch (e) {
    const msg = e.response?.data?.message || e.message;
    yield put(sessionCheckFailure({ error: { message: msg } }));
  }
}
export default function* sessionSaga() {
  yield takeLatest(types.SESSION_CHECK_REQUEST, asyncSessionCheckSaga);
}
